export const LOAD_BOOK_APPOINTMENT_TASKS = "LOAD_BOOK_APPOINTMENT_TASKS";
export const LOAD_BOOK_APPOINTMENT_TASK_TYPES = "LOAD_BOOK_APPOINTMENT_TASK_TYPES";
export const BOOK_INTO_CLINIC = "BOOK_INTO_CLINIC";
export const BOOK_AD_HOC_APPOINTMENT = "BOOK_AD_HOC_APPOINTMENT";
export const BOOK_AD_HOC_CLINIC_APPOINTMENT = "BOOK_AD_HOC_CLINIC_APPOINTMENT";
export const REBOOK_APPOINTMENT = "REBOOK_APPOINTMENT";
export const REQUEST_CHOOSE_AND_BOOK = "REQUEST_CHOOSE_AND_BOOK";
export const CREATE_TIME_NOTE_APPOINTMENT = "CREATE_TIME_NOTE_APPOINTMENT";
export const ADD_BOOKING_NOTES = "ADD_BOOKING_NOTES";

export const LOAD_BOOK_APPOINTMENT_TASKS_SUCCESS = "LOAD_BOOK_APPOINTMENT_TASKS_SUCCESS";

export const LOAD_BOOK_APPOINTMENT_TASK_TYPES_SUCCESS = "LOAD_BOOK_APPOINTMENT_TASK_TYPES_SUCCESS";

export const BOOK_INTO_CLINIC_STARTED = "BOOK_INTO_CLINIC_STARTED";

export const BOOK_INTO_CLINIC_ERROR = "BOOK_INTO_CLINIC_ERROR";

export const BOOK_INTO_CLINIC_SUCCESS = "BOOK_INTO_CLINIC_SUCCESS";

export const BOOK_AD_HOC_APPOINTMENT_STARTED = "BOOK_AD_HOC_APPOINTMENT_STARTED";

export const BOOK_AD_HOC_APPOINTMENT_SUCCESS = "BOOK_AD_HOC_APPOINTMENT_SUCCESS";

export const BOOK_AD_HOC_CLINIC_APPOINTMENT_SUCCESS = "BOOK_AD_HOC_CLINIC_APPOINTMENT_SUCCESS";

export const BOOK_AD_HOC_APPOINTMENT_ERROR = "BOOK_AD_HOC_APPOINTMENT_ERROR";

export const REBOOK_APPOINTMENT_SUCCESS = "REBOOK_APPOINTMENT_SUCCESS";

export const SHOW_ONLY_CLINICS_WITH_INSUFFICIENT_CLINICIANS_CHANGED = "SHOW_ONLY_CLINICS_WITH_INSUFFICIENT_CLINICIANS_CHANGED";

export const CLINIC_TYPE_CHANGED = "CLINIC_TYPE_CHANGED";

export const CLINIC_LOCATION_TYPE_CHANGED = "CLINIC_LOCATION_TYPE_CHANGED";

export const DATE_CHANGED = "DATE_CHANGED";

export const SELECTED_USER_IDS_CHANGED = "SELECTED_USER_IDS_CHANGED";

export const SELECTED_ROOM_IDS_CHANGED = "SELECTED_ROOM_IDS_CHANGED";

export const ADD_BOOKING_NOTES_SUCCESS = "ADD_BOOKING_NOTES_SUCCESS";

export const REQUEST_CHOOSE_AND_BOOK_SUCCESS = "REQUEST_CHOOSE_AND_BOOK_SUCCESS";

export const CREATE_TIME_NOTE_APPOINTMENT_SUCCESS = "CREATE_TIME_NOTE_APPOINTMENT_SUCCESS";

export const LOAD_BOOK_APPOINTMENT_TASKS_DATA = "LOAD_BOOK_APPOINTMENT_TASKS_DATA";
